export const SHOP_STATUS = {
  wait_buyer_pay: '待付款',
  wait_seller_send_goods: '待发货',
  wait_buyer_confirm_goods: '待收货',
  buyer_confirm_goods: '已收货',
  trade_finished: '交易成功',
  trade_closed: '交易关闭',
  refunding: '退款中',
  refunded: '已退款'
}

export const AFTERSALE_STATUS = {
  wait_seller_agree: '申请待受理',
  wait_buyer_return_goods: '待买家退货',
  wait_seller_confirm_goods: '等待商家确认收货',
  seller_refuse_buyer: '已拒绝',
  success: '退款成功',
  closed: '已关闭',
  refunding: '退款中',
  canceled: '已撤销',
  reject_refund: '已拒绝'
}

export const ADMIN_USER_ROLE = {
  super_admin: '超级管理员',
  designer: '设计类',
  customer_service: '客服类'
}

export const GENDER = {
  male: '男',
  female: '女',
  unknow: '未知'
}

export const USER_SUGGESTION_STATUS = {
  pending: '待审核',
  adopted: '已采纳',
  ignored: '已忽略'
}

export const ORDER_COLOR_LABEL = {
  red: '红色',
  orange: '橘色',
  green: '绿色',
  blue: '蓝色'
}

export const PRODUCT_CATEGORY_SCOPE = {
  general: '普通分类',
  member: '会员分类'
}

export const PRODUCT_CATEGORY_LEVEL = {
  first_level: '一级分类',
  second_level: '二级分类',
  third_level: '三级分类',
}

export const PRODUCT_CATEGORY_SHOW_KIND = {
  left_right: '左右图文展示(可不传图片)',
  up_down: '上下图文展示',
}

export const AS_MEMBER_ORDER_STATE = {
  pending: '待支付',
  paid: '已支付',
  closed: '已关闭'
}

export const DEFAULT_ORDER_BY = {
  published_at: '首次发布时间',
  position: '权重'
}

export const MEMBER_CREATED_KIND = {
  sign_up: '小程序注册',
  by_manual: '手动创建'
}

export const TAG_TYPE = {
  wait_buyer_pay: 'info',
  wait_seller_send_goods: 'warning',
  wait_buyer_confirm_goods: '',
  buyer_confirm_goods: '',
  trade_finished: 'success',
  trade_closed: 'info',
  refunding: 'danger',
  refunded: 'warning',
  wait_seller_agree: 'warning',
  wait_buyer_return_goods: '',
  wait_seller_confirm_goods: 'warning',
  seller_refuse_buyer: 'danger',
  success: 'success',
  closed: 'info',
  canceled: 'info',
  reject_refund: 'danger',
  super_admin: 'success',
  designer: '',
  distributor: 'info',
  customer_service: 'warning',
  male: 'success',
  female: 'warning',
  unknow: 'info',
  pending: 'warning',
  adopted: 'success',
  ignored: 'danger',
  general: 'warning',
  member: 'success',
  paid: 'success',
  published_at: 'success',
  position: 'warning',
  sign_up: 'success',
  by_manual: 'info',
  settled: 'success',
  rejected: 'danger',
  blocked: 'warning',
  settlement_processing: 'success'
}

export const KUAIDI_TYPE = {
  JD: '京东物流',
  ZTO: '中通快递',
  YTO: '圆通速递',
  SF: '顺丰速运',
  YD: '韵达快递',
  DBLKY: '德邦物流',
  STO: '申通快递',
  HTKY: '百世快递',
  YZPY: '邮政包裹',
  ZJS: '宅急送',
  EMS: 'EMS'
}

export const COMMISSION_SETTLEMENT_STATUS = {
  pending: '待结算',
  rejected: '已拒绝',
  transfer_processing: '打款中',
  transfer_successed: '打款成功',
  transfer_failed: '打款失败'
}

export const ORDER_COMMISSION_STATUS = {
  blocked: '冻结中',
  pending: '待结算',
  settled: '已结算',
  canceled: '已取消',
  settlement_processing: '正在结算'
}
